import type { ReactNode } from 'react'
import Alert from 'react-bootstrap/Alert'
import { AiOutlineCheckCircle, AiOutlineWarning } from 'react-icons/ai'

type BannerVariant = 'success' | 'warning'

interface BannerProps {
  variant: BannerVariant
  text: string
}

const variantConfig: Record<
  BannerVariant,
  { alertVariant: string; icon: ReactNode; prefix?: string }
> = {
  success: {
    alertVariant: 'success',
    icon: <AiOutlineCheckCircle size={14} className="text-fb-dark-green" />,
  },
  warning: {
    alertVariant: 'warning',
    icon: <AiOutlineWarning size={14} className="text-warning" />,
    prefix: 'Note:',
  },
}

export function Banner({ variant, text }: BannerProps) {
  const config = variantConfig[variant]
  return (
    <Alert variant={config.alertVariant} className="mb-0 py-2">
      <div className="flex items-center gap-2 text-xl">
        {config.icon}
        <i className="text-sm">
          {config.prefix && <strong>{config.prefix} </strong>}
          {text}
        </i>
      </div>
    </Alert>
  )
}
